import api from './api';
import { Task, TaskTypeMeta } from '../types/task';

export interface TaskFilters {
  type?: string[];
  severity?: string[];
  area?: string[];
  owner_id?: number[];
  clinic_id?: number[];
  only_mine?: boolean;
}

export const taskService = {
  async getTasks(tenantId: number, filters: TaskFilters = {}): Promise<Task[]> {
    const params = new URLSearchParams({ tenant_id: tenantId.toString() });
    if (filters.only_mine) params.append('only_mine', 'true');
    (filters.type || []).forEach(t => params.append('type', t));
    (filters.severity || []).forEach(s => params.append('severity', s));
    (filters.area || []).forEach(a => params.append('area', a));
    (filters.owner_id || []).forEach(id => params.append('owner_id', id.toString()));
    (filters.clinic_id || []).forEach(id => params.append('clinic_id', id.toString()));
    const response = await api.get(`/tasks?${params}`);
    return response.data;
  },

  async getPatientTasks(patientId: number, tenantId: number): Promise<Task[]> {
    const response = await api.get(`/tasks/patient/${patientId}?tenant_id=${tenantId}`);
    return response.data;
  },

  async getTaskTypes(): Promise<TaskTypeMeta[]> {
    const response = await api.get('/tasks/types');
    return response.data;
  },
};
